import script from "./ProductsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsList.vue?vue&type=script&setup=true&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&id=829d4a3c&scoped=true&lang=css"
import "./ProductsList.vue?vue&type=style&index=1&id=829d4a3c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-829d4a3c"]])

export default __exports__